import * as React from "react";

function SvgBBiconsFop(props) {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <g data-name="Obecn\xE9 ikony">
        <g data-name="Fyzicka osoba podnikatel">
          <path d="M76.62 17a33.7 33.7 0 1033.69 33.68A33.66 33.66 0 0076.62 17zM52.77 83.74c-20.26 5.3-34.51 19-34.51 48.62 0 24.11 41.7 33.68 75.26 28.94v-28a11.93 11.93 0 0111.88-12h13.27a8.21 8.21 0 011.38.27v-1.35a12.65 12.65 0 0110.28-12.43c-5.72-13.15-16.4-20.53-29.86-24.06A40.77 40.77 0 0181 91.21l-2.81 4.84 6.49 43.32-8.08 14.54-8.1-14.54L75 96l-2.78-4.85a40.9 40.9 0 01-19.45-7.41z" />
          <path d="M132.68 116.26a4 4 0 00-4 4V126a2 2 0 104 0v-5.78h18.56V126a2 2 0 104 0v-5.78a4 4 0 00-4-4zM105.41 130a3.27 3.27 0 00-3.23 3.32v46.38a3.27 3.27 0 003.23 3.32h13.25V130zm19.87 0v53h33.3v-53zm39.92 0v53h13.29a3.28 3.28 0 003.25-3.32V133.3a3.28 3.28 0 00-3.25-3.32z" />
        </g>
      </g>
    </svg>
  );
}

export default SvgBBiconsFop;
